import React, { useState,useEffect } from 'react';
import paymentlink from "../../../assets/images/paymentlink.png"
import close from "../../../assets/images/close.png"
import Switch from '@mui/material/Switch';
import send from "../../../assets/images/send.png"
import copy from "../../../assets/images/copy.png"
import {
    Modal,
    ModalBody,
    Label,
    Form,
    FormGroup,
    Input,ModalHeader
  } from 'reactstrap';
import axiosInstance from '../../../helpers/axios';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function PaymentLink({selectedItems,totalEmiAmount,loanDetails,overdueCharges,chequeBounceCharges,interest,isPreClosure,discountedBounce,discountedPenalty,paidBounce,paidPenalty}){
    // console.log("selected items",selectedItems,overdueCharges,chequeBounceCharges)
    const [amount, setamount] = useState('');
    const [lumpsumAmount, setLumpsumAmount] = useState('');
    const [penaltyAmount, setPenaltyAmount] = useState('');
    const [bounceCharges, setBounceCharges] = useState('');
    const [discountAmount, setDiscountAmount] = useState('');
    const [totalAmount, setTotalAmount] = useState("");
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [formLoader, setFormLoader] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('Hold On...');
    const [formStatusOpen, setStatusOpen] = useState(false);
    const [RepaymentType, setRepaymentType] = useState('Select');
    const [DiscountAmount, setDiscount] = useState(true);
    const [PenaltyAmount, setPenalty] = useState(true);
    const [BounceCharges, setBounce] = useState(true);
    const [paymentLink,setPaymentLink] = useState(null)
    const [showPaymentLinkModal, setShowPaymentLinkModal] = useState(false);
    const [emiAmountDiscount,setEmiAmountDiscount]=React.useState("")
    const [bounceChargesDiscount,setBounceChargesDiscount]=React.useState("")
    const [penaltyDiscount,setPenaltyDiscount]=React.useState("")

    const handleDiscountChange = () => {
        setDiscount(!DiscountAmount);
      };
      const handlePenaltyAmount = () => {
        setPenalty(!PenaltyAmount);
      };
      const handleBounceCharges = () => {
        setBounce(!BounceCharges);
      };
    const popUpStatusForm = () => {
        setStatusOpen(true);
        calculateTotalAmount()
        setBounceChargesDiscount("")
        setPenaltyDiscount("")
        setEmiAmountDiscount("")
        setLumpsumAmount("")
        setTotalAmount("")
      };
      const calculateTotalAmount = () => {
        // console.log("amount",totalEmiAmount)
        const emi = parseFloat(totalEmiAmount) || totalEmiAmount;
        const penalty = parseFloat(penaltyAmount) || 0;
        const bounce = parseFloat(bounceCharges) || 0;
        let discount = parseFloat(discountAmount) || 0;
        const maxDiscount = parseFloat(overdueCharges) + parseFloat(chequeBounceCharges) + parseFloat(interest);
        if (discount > maxDiscount) {
          discount = maxDiscount >= 0 ? maxDiscount : 0;
      }
        const total = emi  - bounceChargesDiscount-emiAmountDiscount-penaltyDiscount;
        setTotalAmount(total);
      };
      // console.log("amount",totalEmiAmount)
    
      useEffect(() => {
        calculateTotalAmount();
      }, [amount, penaltyAmount, bounceCharges, discountAmount,totalEmiAmount]);
      const resetForm = () => {
        setTotalAmount(0)
        setamount('');
        setPenaltyAmount('');
        setBounceCharges('');
        setDiscountAmount('');
        setTotalAmount(0);
      };
      const user = sessionStorage.getItem("user")
    const loanId = sessionStorage.getItem("loanid")
      const handlePayment = () => {
        // setFormLoader(!formLoader);
      setStatusOpen(!formStatusOpen);
      // setConfirmationDialog(!confirmationDialog);
        const formData = {
          loanId:sessionStorage.getItem("legacyLoanId"),
          amount:lumpsumAmount?lumpsumAmount:(totalEmiAmount + chequeBounceCharges + overdueCharges-bounceChargesDiscount-emiAmountDiscount-penaltyDiscount-discountedPenalty-discountedBounce),
          reason : RepaymentType,
          // discount:discountAmount?discountAmount:0,
          penaltyDiscount:Number(penaltyDiscount?penaltyDiscount:0),
          bounceDiscount:Number(bounceChargesDiscount?bounceChargesDiscount:0),
          loanId,
          emiIds:selectedItems,
          whatsappNotification:1,
          emailNotification:1,
          remarks:""
        };
        console.log("formData--->",formData)
        const paymentUrl = `/loan-repayment/payment-link`;
        axiosInstance
        .post(`${paymentUrl}`, formData, {
          headers: {
            Authorization: `Bearer ${user}`,
            'Content-type': 'application/json',
          },
        })
        .then(
          (res) => {
            if (res.data.message === 'Successful') {
                setPaymentLink(res?.data?.data)
                        setShowPaymentLinkModal(true);
                
              }
  
         console.log("formatteddata",res);
          },
          (error) => {
           
            console.log(error)
          },
        ).catch((err)=>{console.log(err)})
       
    };

    const copyToClipboard = () => {
      navigator.clipboard.writeText(paymentLink);
      alert('Payment link copied to clipboard!');
      // setTimeout(() => window.location.reload(true), 500);
    };
    const  togglePaymentLinkModal = ()=>{
      setShowPaymentLinkModal(!showPaymentLinkModal)
        }

    // console.log("repaymenttype-->",totalEmiAmount-bounceChargesDiscount-emiAmountDiscount-penaltyDiscount)
    return(
        <div >
            <img  onClick={() => selectedItems?.length>=1?popUpStatusForm():null} style={{cursor:selectedItems?.length>=1?'pointer':'not-allowed',marginRight:'10px'}} src={paymentlink}/>
            <Modal  isOpen={confirmationDialog}>
                <ModalHeader>Waiting For Confirmation</ModalHeader>
                <ModalBody>{confirmationMessage}</ModalBody>
            </Modal>
            <Modal isOpen={showPaymentLinkModal} toggle={togglePaymentLinkModal} backdrop="static" style={{top:'10%'}}>
        <ModalHeader toggle={togglePaymentLinkModal}>Payment Link</ModalHeader>
        <ModalBody>
          <p style={{fontFamily:'Inter-Medium'}}> {paymentLink}{" "}
          <span onClick={copyToClipboard} style={{ cursor: 'pointer' }}>
              <img src={copy} style={{height:'20px',width:'20px',marginLeft:'50px'}} title='copy to clipboard'/>
            </span>
          </p>
        </ModalBody>
      </Modal>
            {formStatusOpen && (
                <>
                <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 999,
                        }}>
                </div>
                 <Modal style={{
                    
                    width:"500px",
                    
                    top:"4%",
                    borderRadius:"10px",
                }} isOpen={formStatusOpen}>
                  {loanDetails.mandateActive === true ? 
                  <>
                  <div style={{backgroundColor:'#E9E9E9',borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'20px',height:'60px',paddingRight:'20px',paddingTop:'10px'}}>
                        <p style={{fontFamily:'Inter-Medium',fontSize:'20px',fontWeight:'600',color:'#101828'}}>Payment Link</p>
                        <p style={{paddingBottom:'10px'}}><img src={close} style={{cursor:'pointer'}} onClick={() => {resetForm();setStatusOpen(!formStatusOpen);}} /></p>
                    </div>
                    </div>
                    <ModalBody style={{color:'red',fontFamily:'Inter',fontSize:'0.9vw'}}>
                    Mandate is active,cannot generate the payment link.
                    </ModalBody>
                   
                  </>:
                  <>
                  <div style={{backgroundColor:'#E9E9E9',borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',paddingLeft:'20px',height:'60px',paddingRight:'20px',paddingTop:'10px'}}>
                        <p style={{fontFamily:'Inter-Medium',fontSize:'20px',fontWeight:'600',color:'#101828'}}>Payment Link</p>
                        <p style={{paddingBottom:'10px'}}><img src={close} style={{cursor:'pointer'}} onClick={() => {resetForm();setStatusOpen(!formStatusOpen);}} /></p>
                    </div>
                    </div>
                <ModalBody>
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
                <Grid item xs={6}>
                <TextField label="Total Emi Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={totalEmiAmount} disabled/>
                </Grid>
                <Grid item xs={6}>
                <TextField label="Emi Amount Discount"  variant="outlined"  InputLabelProps={{style: { fontSize: '12px' }}} disabled={!isPreClosure}  value={emiAmountDiscount} onChange={(event)=>{setEmiAmountDiscount(event.target.value)}}/>
                </Grid>
                </Grid>
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
                <Grid item xs={6}>
                <TextField label="Total Bounce Charges" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={chequeBounceCharges-discountedBounce-paidBounce} disabled/>
                </Grid>
               
                <Grid item xs={6}>
                <TextField label="Bounce Chrgs Discnt" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={bounceChargesDiscount} disabled={RepaymentType ===4} onChange={(event)=>{setBounceChargesDiscount(event.target.value)}}/>
                </Grid>
                </Grid>
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
                <Grid item xs={6}>
                <TextField label="Total Penlty" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={overdueCharges-discountedPenalty-paidPenalty} disabled/>
                </Grid>
                <Grid item xs={6}>
                <TextField label="Penlty Discount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={penaltyDiscount} disabled={RepaymentType ===4} onChange={(event)=>{setPenaltyDiscount(event.target.value)}}/>
                </Grid>
                </Grid>
                {/* <p style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',paddingLeft:'10px',fontWeight:'600',paddingTop:'10px' }}>Legal Charges: </p> */}
                <Grid container spacing={2} paddingLeft="10px" paddingRight="10px">
                <Grid item xs={6}>
                <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Select Category</Typography>

                <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select" onChange={(e) => setRepaymentType(e.target.value)} value={RepaymentType} style={{border:'none',fontSize:'14px',color:'gray'}}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxWidth: 200,
                        },
                      },
                    }}
                  >
                    <MenuItem value="Select">Select</MenuItem>
                    <MenuItem value={1}>Preclosure</MenuItem>
                    <MenuItem value={2}>Overdue</MenuItem>
                    <MenuItem value={3}>EmiRepayment</MenuItem>
                    <MenuItem value={4}>Custom Amount</MenuItem>
                    <MenuItem value={5}>Settlement</MenuItem>
                    {/* <MenuItem value={6}>Refund By Institute</MenuItem> */}
                  </Select>
                </FormControl>
              </Box>          
                </Grid>
                <Grid item xs={6} marginTop="35px">
                  {RepaymentType === 4 ? (
                <TextField label="Enter Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={lumpsumAmount} onChange={(e) => setLumpsumAmount(e.target.value)}/>
                  ):(
                    <TextField label="Net Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={totalEmiAmount + chequeBounceCharges + overdueCharges-bounceChargesDiscount-emiAmountDiscount-penaltyDiscount-discountedBounce-discountedPenalty} disabled/>
                  )}
                </Grid>
                </Grid>
                
                <Grid container display="flex" justifyContent="center" paddingBottom="15px">
                  <Grid item>
                    <Button style={{backgroundColor:'#D32028',marginTop:'2rem',color:'white'}} onClick={handlePayment}>Generate Link</Button>
                  </Grid>
                </Grid>

                </ModalBody>

                  </>}
                    
                </Modal>
                </>
            )}
        </div>
    )
}